import { Chip } from '@mui/material'
import { Role } from '@shared/types/roles.types'
import { useTranslation } from 'react-i18next'
import { getPaletteColor } from '../utils/theme.utils'
import { isDefaultRole } from '../utils/user.utils'

export default function RoleChip({ role }: { role: Role }) {
  const { t } = useTranslation()
  const color = getPaletteColor(role.color)

  return (
    <Chip
      label={isDefaultRole(role.name) ? t(`role.${role.name}`) : role.name}
      sx={{
        backgroundColor: color.hex,
        color: color.contrast
      }}
    />
  )
}
